import { formValueSelector } from 'redux-form';

import { PREVIEW_WIDTH } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenPreview/InquiryTemplateScreenPreview';
import { FRAME_HEIGHT } from 'verify/components/Application/Frame';

export const INQUIRY_TEMPLATE_EDITOR_FORM_NAME = 'formInquiryTemplateEditor';
// used as a fake form in wrap screen component editor so that validations passed on input fields
export const INQUIRY_TEMPLATE_SCREEN_EDITOR_FORM_NAME = 'formInquiryTemplateScreenEditor';
// used to intercept nested droppable screen actions
export const INQUIRY_TEMPLATE_VERSION_DIFF_FORM_NAME = 'formInquiryTemplateVersionDiff';
export const INQUIRY_TEMPLATE_EDITOR_DRAFT_PLACEHOLDER_ID = 'draft';

export const selector = formValueSelector(INQUIRY_TEMPLATE_EDITOR_FORM_NAME);

export const EDITOR_ROOT_PATH =
  '/dashboard/inquiry-templates/:inquiryTemplateId/:inquiryTemplateVersionId';
export const CONFIG_EDITOR_RELATIVE_PATH = 'config';
export const CONFIG_EDITOR_PATH = `${EDITOR_ROOT_PATH}/${CONFIG_EDITOR_RELATIVE_PATH}`;
export const REVIEW_CHANGES_RELATIVE_PATH = 'review-changes';
export const REVIEW_CHANGES_PATH = `${EDITOR_ROOT_PATH}/${REVIEW_CHANGES_RELATIVE_PATH}`;
export const CONFIG_EDITOR_FIELDS_PATH = `${EDITOR_ROOT_PATH}/config/fields`;
export const CONFIG_EDITOR_VERIFICATION_PATH = `${EDITOR_ROOT_PATH}/config/verifications/:verificationTemplateVersionId`;
export const FLOW_EDITOR_RELATIVE_PATH = 'flow';
export const FLOW_EDITOR_BASE_PATH = `${EDITOR_ROOT_PATH}/${FLOW_EDITOR_RELATIVE_PATH}`;
export const FLOW_EDITOR_NODE_TOKEN_PATH = `${FLOW_EDITOR_BASE_PATH}/:nodeToken`;
export const FLOW_EDITOR_NODE_TOKEN_RELATIVE_PATH = `${FLOW_EDITOR_RELATIVE_PATH}/:nodeToken`;
export const FLOW_EDITOR_ROUTE_INDEX_PATH = `${FLOW_EDITOR_NODE_TOKEN_PATH}/:routeIndex`;
export const FLOW_EDITOR_ROUTE_INDEX_RELATIVE_PATH = `${FLOW_EDITOR_NODE_TOKEN_RELATIVE_PATH}/:routeIndex`;
export const FLOW_EDITOR_PATH = `${FLOW_EDITOR_BASE_PATH}/:nodeToken?/:routeIndex?`;
// TODO (fawn): remove this path and replace it with more proper routes
export const FLOW_EDITOR_MILESTONE1_RELATIVE_PATH = 'milestone1';
export const FLOW_EDITOR_MILESTONE1_PATH = `${FLOW_EDITOR_BASE_PATH}/${FLOW_EDITOR_MILESTONE1_RELATIVE_PATH}`;
export const SCREEN_EDITOR_RELATIVE_PATH = 'screens';
export const SCREEN_EDITOR_STEP_RELATIVE_PATH = `${SCREEN_EDITOR_RELATIVE_PATH}/:stepName`;
export const SCREEN_EDITOR_COMBINED_RELATIVE_PATH = `${SCREEN_EDITOR_STEP_RELATIVE_PATH}/:combinedStepScreenNameOrComponentName`;
export const SCREEN_EDITOR_BASE_PATH = `${EDITOR_ROOT_PATH}/${SCREEN_EDITOR_RELATIVE_PATH}`;
export const SCREEN_EDITOR_STEP_PATH = `${SCREEN_EDITOR_BASE_PATH}/:stepName`;
export const SCREEN_EDITOR_PATH = `${SCREEN_EDITOR_BASE_PATH}/:stepName?/:combinedStepScreenNameOrComponentName?`;
export const PREVIEW_PATH = `${EDITOR_ROOT_PATH}/preview`;
export const THEME_EDITOR_RELATIVE_PATH = 'theme';
export const THEME_EDITOR_PATH = `${EDITOR_ROOT_PATH}/${THEME_EDITOR_RELATIVE_PATH}`;
export const WORKFLOW_EDITOR_RELATIVE_PATH = 'actions/:workflowVersionId';
export const WORKFLOW_EDITOR_BASE_PATH = `${EDITOR_ROOT_PATH}/${WORKFLOW_EDITOR_RELATIVE_PATH}`;
export const WORKFLOW_EDITOR_STEP_TOKEN_PATH = `${WORKFLOW_EDITOR_BASE_PATH}/:workflowStepToken`;
export const WORKFLOW_EDITOR_STEP_TOKEN_RELATIVE_PATH = `${WORKFLOW_EDITOR_RELATIVE_PATH}/:workflowStepToken`;
export const WORKFLOW_EDITOR_CONDITIONAL_ROUTE_RELATIVE_PATH = `${WORKFLOW_EDITOR_STEP_TOKEN_RELATIVE_PATH}/:conditionalRouteIndex`;
export const WORKFLOW_EDITOR_PATH = `${WORKFLOW_EDITOR_BASE_PATH}/:workflowStepToken?/:conditionalRouteIndex?`;
export const WORKFLOW_RUNS_RELATIVE_PATH = 'workflow-runs';
export const WORKFLOW_RUNS_PATH = `${EDITOR_ROOT_PATH}/${WORKFLOW_RUNS_RELATIVE_PATH}`;

export const MAX_ROUTES_PER_BRANCHING_FOR_NON_ENHANCED = 3;

// TODO(Ernest): update other constants to use this
export const PANEL_WIDTH = 250;

export const LOAD_VERSION_DIFF_ERROR_MESSAGE =
  'Unable to display the changes since the last published version. You can continue publishing this template, or refresh and try again.';

export const DEFAULT_SCREEN_DIMENSIONS = {
  height: FRAME_HEIGHT,
  width: PREVIEW_WIDTH,
};

export const SCREEN_CONTAINER_TO_PARENT_RATIO = 0.9;

export const CONFIG_EDITOR_RIGHT_PANEL_ID = 'ite-config-editor__right-panel';
